import restApiHost from ".."

export async function changeUserImageRequest(userId, imageId) {
      await fetch(restApiHost + '/api/change-image/', {
        method: 'POST', // Указываем метод POST
        headers: {
          'Content-Type': 'application/json' // Указываем тип контента как JSON
        },
        body: JSON.stringify({
            user_id: userId,
            image_id: imageId
        }) // Передаем тело запроса с ключом request_url
      })
};

export async function changeUserNameRequest(userId, name) {
      await fetch(restApiHost + '/api/change-name/', {
        method: 'POST', // Указываем метод POST
        headers: {
          'Content-Type': 'application/json' // Указываем тип контента как JSON
        },
        body: JSON.stringify({
            user_id: userId,
            name: name
        }) // Передаем тело запроса с ключом request_url
      })
};

